import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

import 'swiper/css/bundle';

export default () => {
	[...document.querySelectorAll('.case-studies-carousel__row')].forEach(el => {
		const carouselEl = el.querySelector('.case-studies-carousel.swiper');
		const carouselPrev = el.querySelector('.swiper-carousel__prev');
		const carouselNext = el.querySelector('.swiper-carousel__next');

		if (!carouselEl) return;

		const hasNav = carouselPrev && carouselNext;

		new Swiper(carouselEl, {
			modules: hasNav ? [Navigation] : [],
			...(hasNav
				? {
						navigation: {
							prevEl: carouselPrev,
							nextEl: carouselNext,
						},
					}
				: {}),
			slidesPerView: 1.08,
			spaceBetween: 16,
			speed: 600,
			rewind: true,
			watchOverflow: true,
			breakpoints: {
				640: {
					slidesPerView: 1.35,
					spaceBetween: 20,
				},
				780: {
					slidesPerView: 2,
					spaceBetween: 24,
				},
				1124: {
					slidesPerView: 2.35,
					spaceBetween: 24,
				},
				1400: {
					slidesPerView: 3,
					spaceBetween: 24,
				},
			},
		});
	});
};
